(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    document.querySelectorAll('.buy-buttons-block[data-block-id]').forEach((currentBlock) => {
      const blockId = currentBlock.dataset.blockId;
      const newBlock = html.querySelector(`.buy-buttons-block[data-block-id="${blockId}"]`);
      if (!newBlock) return;

      const currentIsEnquiry = currentBlock.querySelector('.product-enquiry-form') !== null;
      const newIsEnquiry = newBlock.querySelector('.product-enquiry-form') !== null;

      if (currentIsEnquiry !== newIsEnquiry) {
        currentBlock.innerHTML = newBlock.innerHTML;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
